module.exports = "<navbar></navbar>\n\n<div  class=\"RouterContainer\">\n<router-outlet></router-outlet>\n</div>\n"